package dev.akshaychordiya.pages.articles

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initMigratingLegacyCodeToKotlinFlowPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("articles/MigratingLegacyCodeToKotlinFlow.md", FrontMatterElement.Builder { addScalar("title", "Migrating from legacy code  Kotlin Flow"); addScalar("date", "2020-06-25"); addScalar("description", "A lot of the codebases are stuck with legacy code either callbacks, RxJava 1, loaders or other old asynchronous programming APIs and it’s totally fine!"); addScalar("originalUrl", "https://medium.com/@aky/migrating-legacy-code-to-kotlin-flow-3f3e1854925"); addScalar("originalName", "Medium"); addScalar("image", "/images/articles/migrating-legacy-code-to-kotlin-flow/1ycHNUUxDmHljneH1yLLngw.webp"); }))
}

@Page("/articles/migrating-legacy-code-to-kotlin-flow")
@Layout(".components.layouts.ArticleLayout")
@Composable
fun MigratingLegacyCodeToKotlinFlowPage() {
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/images/articles/migrating-legacy-code-to-kotlin-flow/1ycHNUUxDmHljneH1yLLngw.webp", "")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Birds migrating. Photo by ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/@gdfoto?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText") {
                org.jetbrains.compose.web.dom.Text("Gareth Davies")
            }
            org.jetbrains.compose.web.dom.Text(" on ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://unsplash.com/?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText") {
                org.jetbrains.compose.web.dom.Text("Unsplash")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("content") }) {
        org.jetbrains.compose.web.dom.Text("Content")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/google-developer-experts/go-with-the-kotlin-flow-7067564665a3") {
                org.jetbrains.compose.web.dom.Text("Go with the Kotlin Flow 🌊")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Diving deeper into Kotlin Flow 🏊‍♂️ [Coming soon]")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/@aky/migrating-legacy-code-to-kotlin-flow-3f3e1854925") {
                org.jetbrains.compose.web.dom.Text("Migrating from legacy code to Kotlin Flow 🚚")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Flow on Android 🤖 [Coming soon]")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A lot of the codebases are stuck with legacy code either callbacks, RxJava 1, loaders or other old asynchronous programming APIs and it’s totally fine!")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If it’s working it’s great but the problem lies with ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("slower")
        }
        org.jetbrains.compose.web.dom.Text(" 🐌 and ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("hard")
        }
        org.jetbrains.compose.web.dom.Text(" code maintenance and refactoring when there is a (new) requirement. This slows the efficiency and the velocity ⏩ of developing the given requirement.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("basic idea of refactoring")
        }
        org.jetbrains.compose.web.dom.Text(" is to make the code more efficient and maintainable so we can build 🛠 and deliver 📦 things faster ⚡️")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This article is meant to provide how you can build a process to ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("gradually")
        }
        org.jetbrains.compose.web.dom.Text(" migrate from legacy asynchronous APIs mainly showcasing RxJava to Kotlin Flow and Coroutines.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The process can be applied even if you are planning to migrate to some other alternative which suits your team and you the best 🥇")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The article is ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("not")
        }
        org.jetbrains.compose.web.dom.Text(" meant to explain ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://medium.com/google-developer-experts/go-with-the-kotlin-flow-7067564665a3") {
            org.jetbrains.compose.web.dom.Text("what Kotlin Flow is")
        }
        org.jetbrains.compose.web.dom.Text(" and also not about why you should migrate to Kotlin Flow [you need to evaluate that 😛].")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("setting-up-the-migration-process") }) {
        org.jetbrains.compose.web.dom.Text("Setting up the migration process 🚚")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Setting up the process with the team is super important so the whole team works towards the single goal of migration 🥅")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("1-discuss-with-your-team") }) {
        org.jetbrains.compose.web.dom.Text("1. Discuss with your team 🎳")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("First order of business is to discuss within your team and trying to figure what alternative to pick, that works for your team and the use-case you are trying to solve.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I’d recommend doing as followed 👇 to get started and decide what other tool suits the best for your codebase:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Setup a meeting 📅 with the team and list out all the possible alternatives like RxJava 2, 3 or Flow.    Discuss the pros — cons — advantages of all the options.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It’s best if the team gets to try out and get comfortable 🛋 with the option you all like, this might include doing a small sample app, giving an internal presentation, articles, talks, etc.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It’s also important to evaluate 🧮 how hard the migration of certain option looks like for your codebase, the learning curve for new joiners to the team.    For instance, we at ")
            com.varabyte.kobweb.silk.components.navigation.Link("http://helloclue.com/") {
                org.jetbrains.compose.web.dom.Text("Clue")
            }
            org.jetbrains.compose.web.dom.Text(" migrated from RxJava 1 to Flow and we had evaluated RxJava 2 and 3 at that time and for our codebase it would have been super hard and we really liked Flow and everyone felt comfortable with it 🛋")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("At the end of this, you have a common goal 🎯 in mind; for example migrate from RxJava 1 to Flow.")
        }
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("For this article let’s say it was decided to use Kotlin Flow 🌊")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("2-setup-foundation") }) {
        org.jetbrains.compose.web.dom.Text("2. Setup foundation ⛲️⛩")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Setting up the foundation is very key 🗝 to the whole migration because it’s what will motivate the team to write the new code in Flow or whatever is decided.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You don’t want any developer to start thinking to write the new feature in Flow and then realise there is no testing framework 🤷‍♂️ which will make the developer go back into comfort zone 🛀 since all of us are humans.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Hence make sure to:")
    }
    org.jetbrains.compose.web.dom.Ol {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Setup guidelines with standard practices 📑 of how team decided to use Flow throughout the codebase")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Setup the necessary base classes for your codebase and to work with your architecture including the dependencies")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Setup the testing framework / utilities so it’s easier to do get started and do testing like ")
            com.varabyte.kobweb.silk.components.navigation.Link("https://craigrussell.io/2019/11/unit-testing-coroutine-suspend-functions-using-testcoroutinedispatcher/") {
                org.jetbrains.compose.web.dom.Text("setting up the dispatchers")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Each codebase has some base APIs which are commonly used by features like getting the user details. It’s ideal if those base APIs are exposed as Flow equivalent functions as described below 👇")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Converting commonly used APIs as Flow")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("ideal scenario")
        }
        org.jetbrains.compose.web.dom.Text(" 🌈 is if you can right away convert the existing function to use Flow or coroutine, usually this is a problem cause the function is very likely used in a lot of places in the app, this forces to update all the usages and it’s not great to spend time fixing this everywhere in the whole app and not to mention testing 🔥")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("optimal path")
        }
        org.jetbrains.compose.web.dom.Text(" is to ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("gradually")
        }
        org.jetbrains.compose.web.dom.Text(" migrate 🧱🏰, one idea is to")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Duplicate 👯‍♂️ those base APIs and expose the duplicated API as Flow or coroutine")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For instance,")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("interface UserRepository {\n    // Legacy function\n    fun observeUser(): Observable<User>\n    \n    // Flow equivalent of [observeUser].\n    fun getUser(): Flow<User>\n}\n") } }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Mark the legacy function as @Deprecated so everyone uses the new function and avoids the legacy one ☠️")
        }
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("interface UserRepository {\n    // Legacy function\n    [@Deprecated](http://twitter.com/Deprecated)(\n        message = \"Use the flow equivalent -> getUser()\", \n        replaceWith = ReplaceWith(\"getUser()\", \"<package>\")\n    )\n    fun observeUser(): Observable<User>\n    \n    // Flow equivalent of [observeUser].\n    fun getUser(): Flow<User>\n}\n") } }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Try to extract the business logic 💵 so the existing function and new Flow function shares the same logic preventing updating it twice when needed")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("3-setup-safeguards") }) {
        org.jetbrains.compose.web.dom.Text("3. Setup safeguards ☢️")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now that we are super motivated to write Kotlin Coroutines, Safeguards will prevent kinda force the team to write more and more code 📈 in Kotlin Flow / Coroutines and also convert the legacy code.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Some of the safeguards can be:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Ensuring that the new code is written using Kotlin Coroutines while doing the PR reviews")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Ensuring when the legacy code is touched, the developer has tried to convert it coroutines or flow")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Monthly or quarterly checking of progress of the gradual migration 🚚")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("And other ideas which will pop in your brilliant minds 🧠")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("4-interoperability") }) {
        org.jetbrains.compose.web.dom.Text("4. Interoperability")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The key to success 💯 of Java-Kotlin migration was interoperability and ease of using one from another which opened the doors 🚪 for gradual migration.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Similarly having this ability allows to quickly interop between the legacy code and Flow or Coroutines which can drastically change the landscape 🏔")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("For instance, having a helper function to convert Observable to Flow saves a lot time ⏳ for developer when they want to focus on building something rather than spending time migrating legacy code at that moment.")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("rxjava-2-3-flow") }) {
        org.jetbrains.compose.web.dom.Text("RxJava 2/3 ↔️ Flow")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Kotlin Flow follows the reactive stream specification 📄 which is followed in RxJava which makes things conceptually similar to understand.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Plus, Kotlin Coroutines library provides the functions to easily convert Single / Maybe / Completable to coroutines and Observable / Flowable to Flow and the reverse.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can find those helper functions here:")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/Kotlin/kotlinx.coroutines/blob/master/reactive/README.md") {
            org.jetbrains.compose.web.dom.Text("Kotlin/kotlinx.coroutines")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("rxjava-1-flow") }) {
        org.jetbrains.compose.web.dom.Text("RxJava 1 ↔️ Flow")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Migrating from RxJava 1 to Kotlin Flow or Coroutines is bit tricky since there isn’t official support from Kotlin Team [which makes sense since it’s super old].")
    }
    org.jetbrains.compose.web.dom.Blockquote {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("One of the factor why one should migrate from legacy code is when the legacy library is not supported anymore which also makes it hard to use modern libraries and tools ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("😞")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This is one of the factor why one should migrate from legacy code.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Luckily, I recently created a library 👇 with the necessary APIs to provide the similar functionality of converting Single / Maybe / Completable to coroutines and Observable to Flow and the reverse.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/AkshayChordiya/kotlinx.coroutines-rx1") {
            org.jetbrains.compose.web.dom.Text("AkshayChordiya/kotlinx.coroutines-rx1")
        }
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("callback-based-flow") }) {
        org.jetbrains.compose.web.dom.Text("Callback based ↔️ Flow")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Kotlin coroutines library provides are mainly 2 different APIs to deal with callback 🔀 based legacy code.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Though ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlinlang.org/api/latest/jvm/stdlib/kotlin.coroutines/suspend-coroutine.html") {
            org.jetbrains.compose.web.dom.Text("suspendCoroutine")
        }
        org.jetbrains.compose.web.dom.Text(" is part of Kotlin standard library and unlike ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines/suspend-cancellable-coroutine.html") {
            org.jetbrains.compose.web.dom.Text("suspendCancellableCoroutine")
        }
        org.jetbrains.compose.web.dom.Text(" it doesn’t support cancellation ✋")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("suspendcoroutine-suspendcancellablecoroutine") }) {
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlinlang.org/api/latest/jvm/stdlib/kotlin.coroutines/suspend-coroutine.html") {
            org.jetbrains.compose.web.dom.Text("suspendCoroutine")
        }
        org.jetbrains.compose.web.dom.Text(" / ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines/suspend-cancellable-coroutine.html") {
            org.jetbrains.compose.web.dom.Text("suspendCancellableCoroutine")
        }
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines/suspend-cancellable-coroutine.html") {
            org.jetbrains.compose.web.dom.Text("suspendCancellableCoroutine")
        }
        org.jetbrains.compose.web.dom.Text(" allows to convert callback based API 🔀 to a suspending function aka coroutine.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("It does that by providing ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/Kotlin/KEEP/blob/master/proposals/coroutines.md#continuation-passing-style") {
            org.jetbrains.compose.web.dom.Text("continuation")
        }
        org.jetbrains.compose.web.dom.Text(" instance which gives us control over the suspension and we are responsible to guide it.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Here is an example of ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines/suspend-cancellable-coroutine.html") {
            org.jetbrains.compose.web.dom.Text("suspendCancellableCoroutine")
        }
        org.jetbrains.compose.web.dom.Text(" with callback based API of Retrofit library:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("suspend fun <T> Call<T>.await(): Response<T> {\n    return suspendCancellableCoroutine **{ **continuation **->\n        **continuation.invokeOnCancellation **{ **cancel() **}\n        **enqueue(object : Callback<T> {\n            override fun onFailure(call: Call<T>, error: Throwable){\n                continuation.*resumeWithException*(error)\n            }\n\n            override fun onResponse(\n                call: Call<T>,\n                response: Response<T>\n            ) {\n                continuation.resume(response) **{ **cancel() **}\n            **}\n        })\n    **}\n**}\n") } }
    org.jetbrains.compose.web.dom.H3(attrs = { id("callbackflow") }) {
        org.jetbrains.compose.web.dom.Text("callbackFlow")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/callback-flow.html") {
            org.jetbrains.compose.web.dom.Text("callbackFlow")
        }
        org.jetbrains.compose.web.dom.Text(" allows to convert callback listeners to Flow . It internally creates a channel to which we can send the values produced by the callbacks and remove the listener when the flow is cancelled.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Here is an example of ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://kotlin.github.io/kotlinx.coroutines/kotlinx-coroutines-core/kotlinx.coroutines.flow/callback-flow.html") {
            org.jetbrains.compose.web.dom.Text("callbackFlow")
        }
        org.jetbrains.compose.web.dom.Text(" with callback based listeners from ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/ReactiveCircus/FlowBinding") {
            org.jetbrains.compose.web.dom.Text("FlowBinding")
        }
        org.jetbrains.compose.web.dom.Text(" library to get stream of clicks as Flow:")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code(attrs = { classes("language-kotlin") }) { org.jetbrains.compose.web.dom.Text("fun View.clicks(): Flow<Unit> = *callbackFlow ***{\n    **val listener = View.OnClickListener **{ **offer(Unit) **}\n    **setOnClickListener(listener)\n    awaitClose **{\n        **setOnClickListener(null)\n    **}\n}**\n") } }
    org.jetbrains.compose.web.dom.H2(attrs = { id("final-thoughts") }) {
        org.jetbrains.compose.web.dom.Text("Final thoughts 💭")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Legacy code can sometimes be painful but it’s important to distinguish between a real problem or new needs vs some cool new tool out there i.e unless you have a real problem or new requirement there is no real reason for you to migrate 🚚")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Whatever tool you decide it’s important to work as a team and setup the migration strategy / process and work towards the common goal 🏆 and iterate ♼")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Please leave some claps 👏 if you learned something or enjoyed the article or loved my emojis or all of it.")
    }
}
